$(document).ready(function () {
  // Function to check if an element is in the viewport
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Function to lazy load background images
  function lazyLoadBgImages(entries) {
    entries.forEach(function (entry) {
      var section = $(entry.target);

      if (entry.isIntersecting && !section.hasClass('loaded')) {
        // Set background image from data-src attribute
        var imageUrl = section.data('src');

        // Use .css() method to set background image for the current element only
        section.attr('style', imageUrl);

        // Add a class to mark the section as loaded
        section.addClass('loaded');
      }
    });
  }

  // Initialize Intersection Observer
  var observerBgImages = new IntersectionObserver(lazyLoadBgImages);

  // Observe each .section element
  $('.section').each(function () {
    observerBgImages.observe(this);
  });


  // Function to lazy load normal images
  function lazyLoadNormalImages(entries) {
    entries.forEach(function (entry) {
      var section = $(entry.target);

      if (entry.isIntersecting && !section.hasClass('loaded')) {
        // Set background image from data-src attribute
        var imageUrl = section.data('src');

        // Use .css() method to set background image for the current element only
        section.attr('src', imageUrl);

        // Add a class to mark the section as loaded
        section.addClass('loaded');
      }
    });
  }

  // Initialize Intersection Observer
  var observerNormalImages = new IntersectionObserver(lazyLoadNormalImages);

  // Observe each .section element
  $('img').each(function () {
    observerNormalImages.observe(this);
  });
});
